import ApiClient from './ApiClient';

// Surfaces backend structured errors ({ error: "..." }) — mirrors TasksClient/ColoClient.
const extractErrorMessage = (error, fallback) =>
  error?.response?.data?.error || error?.message || fallback;

const toCamelKey = key => key.charAt(0).toLowerCase() + key.slice(1);

const toCamelCaseShallow = obj => {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [toCamelKey(key), value])
  );
};

const toCamelCaseArray = arr => (arr ?? []).map(toCamelCaseShallow);

class HelpDeskClient extends ApiClient {
  constructor(url) {
    super(url ? `${url}/helpdesk` : '/helpdesk');
  }

  async getRequests() {
    try {
      const data = await this.get('/requests');
      return toCamelCaseArray(data?.requests);
    } catch (error) {
      throw new Error(
        extractErrorMessage(error, 'Failed to fetch help desk requests.')
      );
    }
  }

  // body: { contactEmail, subject, message }
  async createRequest(body) {
    try {
      const data = await this.post('/requests', body);
      return toCamelCaseShallow(data?.request);
    } catch (error) {
      throw new Error(
        extractErrorMessage(error, 'Failed to submit help desk request.')
      );
    }
  }
}

export default HelpDeskClient;
